import { useCallback } from 'react';

export enum PostMessageType {
  resize = 'resize',
  open_imgs_overlay = 'open_imgs_overlay',
  present_visit_places_data = 'present_visit_places_data',
  scroll_to_highlight = 'scroll_to_highlight',
  scroll_to_form_section = 'scroll_to_form_section',
}

function useEmbed() {
  const sendPostMessage = useCallback((type: PostMessageType, data: any) => {
    if (window.parent) {
      window.parent.postMessage({ type, data }, '*');
    }
  }, []);

  return {
    sendPostMessage,
  };
}

export default useEmbed;
